const callbackNames = ["onKeyDown", "onFrameSelect", "onImageAssign", "onClearSelection", "onValidateBasket", "onValidateStep"]

export const PrintessCallbacksMixin = (Base) =>
  class extends Base {
    #printessCallbacks;

    connect () {
      this.#printessCallbacks = {};

      super.connect();
    }

    handlePrintessBridge (method, ...args) {
      if (callbackNames.includes(method)) {
        return (this.#printessCallbacks[method] || []).forEach(fn => fn(...args));
      }

      super.handlePrintessBridge(method, ...args);
    }

    addPrintessCallbackHandler (callbackName, handler) {
      this.#printessCallbacks[callbackName] ||= []
      this.#printessCallbacks[callbackName].push(handler)
    }
  }
